<template>
  <Transition name="sport-live-tv-dropdown">
    <slot />
  </Transition>
</template>

<style lang="scss">
.sport-live-tv-dropdown-enter-active,
.sport-live-tv-dropdown-leave-active {
  transition: opacity 0.2s ease-in-out, transform 0.2s ease-in-out;
}

.sport-live-tv-dropdown-enter-from,
.sport-live-tv-dropdown-leave-to {
  opacity: 0;
  transform: translateY(-8px);
}
</style>
